import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy"
export default class extends Controller {
  connect() {
    console.log("copy controller connected");
    // 为元素添加提示
    this.element.title = '点击复制';
  }

  copy() {
    const text = this.element.dataset.copyText;
    console.log("copy content:", text);

    if (!text) {
      console.error("没有要复制的内容");
      return;
    }

    // 尝试复制到剪贴板
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        this.showCopySuccess();
      }).catch((err) => {
        console.error("复制失败:", err);
        this.fallbackCopy(text);
      });
    } else {
      // 备用方案
      this.fallbackCopy(text);
    }
  }

  // 备用复制方案
  fallbackCopy(text) {
    try {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);

      if (successful) {
        this.showCopySuccess();
      } else {
        this.showCopyError();
      }
    } catch (err) {
      console.error('备用复制方案失败:', err);
      this.showCopyError();
    }
  }

  // 显示复制成功
  showCopySuccess() {

    // 显示成功popup
    this.showPopup('复制成功！', 'success');

  }

  // 显示复制失败
  showCopyError() {

    // 显示失败popup
    this.showPopup('复制失败，请手动选择', 'error');

  }

  // 显示popup提示
  showPopup(message, type = 'success') {
    // 创建popup元素
    const popup = document.createElement('div');
    popup.className = `fixed top-4 right-4 z-50 px-4 py-2 rounded-lg shadow-lg transform transition-all duration-300 ease-in-out ${type === 'success'
      ? 'bg-indigo-500 text-white'
      : 'bg-yellow-500 text-white'
      }`;
    popup.textContent = message;

    // 添加图标
    const icon = document.createElement('span');
    icon.className = 'mr-2';
    icon.innerHTML = type === 'success' ? '✓' : '✗';
    popup.insertBefore(icon, popup.firstChild);

    // 添加到页面
    document.body.appendChild(popup);

    // 动画效果：从右侧滑入
    popup.style.transform = 'translateX(100%)';
    popup.style.opacity = '0';

    // 触发动画
    setTimeout(() => {
      popup.style.transform = 'translateX(0)';
      popup.style.opacity = '1';
    }, 10);

    // 3秒后自动消失
    setTimeout(() => {
      popup.style.transform = 'translateX(100%)';
      popup.style.opacity = '0';

      setTimeout(() => {
        if (popup.parentNode) {
          popup.parentNode.removeChild(popup);
        }
      }, 300);
    }, 3000);
  }
}
